import { Card, Chip, Typography, Box, CardActionArea, IconButton } from '@mui/material';
import defaultImage from '../../../img/courses/courseDefaultImage.webp'; // Default image for missing course image
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';

export default function CourseCard({ img, title, project, age, status, isDiscriptionAdded, setOpenAddCourse, row }) {
  return (
    <Card
      sx={{
        width: '100%',
        maxHeight: 400,
        borderRadius: 3,
        boxShadow: 3,
        position: 'relative',
      }}
    >
      <CardActionArea>
        <IconButton
          sx={{
            position: 'absolute',
            top: 12,
            left: 12,
            zIndex: 99,
            color: 'white',
            bgcolor: '#0b7d99ff',
            ':hover': {
              bgcolor: '#ddddddff',
            },
          }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setOpenAddCourse(row);
          }}
        >
          {isDiscriptionAdded ? <ModeEditOutlineOutlinedIcon /> : <AddOutlinedIcon />}
        </IconButton>
        <Chip
          label={status ? 'Active' : 'In active'}
          color={status ? 'success' : 'error'}
          size="small"
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            fontWeight: 600,
          }}
        />
        <Box
          component="img"
          maxHeight={400}
          minHeight={400}
          width="100%"
          // src={img ?? defaultImage} live
          src={img && !img.endsWith('null') ? img : defaultImage}
          alt="img"
          sx={{ objectFit: 'cover' }}
        />
        <Box
          position={'absolute'}
          sx={{
            bottom: 12,
            left: 12,
          }}
        >
          <Typography
            variant="h6"
            fontWeight={700}
            bgcolor={'#D9D9D9'}
            borderRadius={3}
            px={1}
            sx={{
              textAlign: 'center',
            }}
          >
            {title}
          </Typography>

          <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
            {isDiscriptionAdded && (
              <Chip
                label={age}
                size="small"
                sx={{
                  bgcolor: '#4fc3f7',
                  color: '#000',
                  fontWeight: 600,
                }}
              />
            )}
            {Boolean(project) && (
              <Chip
                label={project}
                size="small"
                sx={{
                  bgcolor: '#81d4fa',
                  color: '#000',
                  fontWeight: 600,
                }}
              />
            )}
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
}
